<template>
  <div class="lesson-item">
    <div class="lesson-exp">
      <div class="action-btns">
        <el-card v-if="canEdit" class="box-card">
          <el-button type="text" icon="el-icon-edit-outline" @click="beforeAdd">发布实验</el-button>
          <el-button
              type="text"
              icon="el-icon-s-order"
              style="float:right;color:#E6A23C"
              @click="openExpLog"
          >
            查看实验日志
          </el-button>
        </el-card>
      </div>

      <is-empty class="notices-list" :show="list.length > 0" message="暂无实验~">
        <div class="lesson-list">
          <el-card class="box-card" shadow="hover" v-for="(item, index) in list" :key="item.uid">
            <div slot="header" class="clearfix">
              <span class="lesson-title">
                  <span v-text="`${page.limit * (page.page - 1) + index + 1}、${item.name}`"></span>
                  <el-tag size="small" type="warning" v-if="item.type">
                    {{
                      item.type === 1
                          ? '创新型实验'
                          : item.type === 2
                          ? '设计型实验'
                          : item.type === 3
                              ? '验证型实验'
                              : '故障型实验'
                    }}
                  </el-tag>
                  <el-tag size="small" type="warning" effect="plain" v-if="item.periods">
                    {{ `${item.periods}课时` }}
                  </el-tag>
              </span>
              <div class="action-btns-right" v-if="canEdit">
                <el-dropdown
                    trigger="click"
                    @command="handleCommand($event, item, index)"
                >
                  <span class="el-dropdown-link">
                    <i class="el-icon-more el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="el-icon-edit" command="update">编辑实验</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-view" command="see">查看详情</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-delete" command="remove">删除</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-top" command="moveup">上移</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-bottom" command="movedown">下移</el-dropdown-item>
                    <template v-if="setDept">
                      <el-dropdown-item
                          icon="el-icon-s-cooperation"
                          command="pack"
                          :disabled="item.packFlag || item.packStatus === 1"
                      >
                        打包pdf
                      </el-dropdown-item>
                      <el-dropdown-item
                          icon="el-icon-download"
                          command="download"
                          :disabled="!item.packFileUrl"
                      >
                        下载pdf
                      </el-dropdown-item>
                      <el-dropdown-item
                          icon="el-icon-s-cooperation"
                          command="packWord"
                          :disabled="item.packFlag || item.wordPackStatus === 1"
                      >
                        打包word
                      </el-dropdown-item>
                      <el-dropdown-item
                          icon="el-icon-download"
                          command="downloadWord"
                          :disabled="!item.wordPackFileUrl"
                      >
                        下载word
                      </el-dropdown-item>
                    </template>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div class="lesson-body">
              <div class="info">
                <p class="word p">{{ item.remark }}</p>
                <el-tag size="mini" type="success" v-for="tag in item.tagName" :key="tag.index" effect="plain">
                  {{ tag }}
                </el-tag>
                <div class="time">
                  <span class="item" v-text="item.createTime"></span>
                  <span class="item" v-text="item.cutoffTime"></span>
                  <el-tag size="small" :type="item.status === 2 ? 'danger' : ''">
                    {{ item.statusText }}
                  </el-tag>
                </div>
              </div>
              <div class="action">
                <el-button
                    v-if="(canEdit && item.openReservation)"
                    type="warning"
                    size="small"
                    plain
                    @click="seeAppointDetail(item.expUid)"
                >
                  查看预约
                </el-button>
                <el-button type="info" size="small" plain @click="openExpStep(item.expUid)">
                  查看实验指导书
                </el-button>
                <el-button
                    type="primary"
                    size="small"
                    :disabled="item.status !== 1"
                    @click="selectExpType(item)"
                    v-if="item.softNum"
                >
                  开始实验
                </el-button>
                <el-button
                    type="primary"
                    size="small"
                    @click="handleStartMark(item.uid)"
                    v-if="canEdit"
                >
                  报告批阅
                </el-button>
                <el-button
                    type="primary"
                    size="small"
                    @click="handlecheckReprot(item.uid)"
                    :disabled="!item.isSubReport"
                >
                  查看报告
                </el-button>
              </div>
            </div>
          </el-card>

          <el-pagination
              style="margin-top:15px"
              background
              hide-on-single-page
              prev-text="上一页"
              next-text="下一页"
              layout="total, prev, pager, next, jumper"
              :total="page.total"
              :current-page="page.page"
              :page-size="page.limit"
              :pager-count="page.pagerCount"
              @current-change="handlePageChange"
          />
        </div>
      </is-empty>

      <el-dialog width="600px" :title="`${form.id ? '编辑' : '添加'}实验项目`" :visible.sync="box">
        <el-form ref="form" :rules="rules" :model="form" label-width="110px">
          <el-form-item label="实验项目" prop="expUid">
            <el-cascader
                class="dialog-cascader"
                v-model="form.expUid"
                :options="expList"
                :props="{
                  value: 'uid',
                  label: 'name',
                }"
                placeholder="请选择实验项目"
                clearable
                filterable
                @change="cascaderChange"
            />
          </el-form-item>
          <template v-if="form.isGroup === '1'">
            <el-form-item label="选择分组" prop="groupUid">
              <el-select v-model="form.groupUid" placeholder="请选择分组">
                <el-option
                    v-for="group in groupList"
                    :key="group.uid"
                    :label="group.name"
                    :value="group.uid"
                />
              </el-select>
            </el-form-item>
            <el-button @click="gotoGroupPage">新建分组</el-button>
          </template>
          <el-form-item label="课时" prop="periods">
            <el-input-number
                v-model="form.periods"
                step-strictly
                style="width: 100%;"
                label="请输入课时"
                :min="0"
                :step="0.5"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="选择报告模版">
            <el-select v-model="form.mouldId" style="width: 100%;" clearable placeholder="请选择" :disabled="disabled">
              <el-option v-for="item in reports" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报告题目数量" prop="reportNum" v-if="!form.mouldId">
            <el-input-number v-model="form.reportNum" style="width: 100%;" :min="1" :max="3" label="请输入报告题目数量">
            </el-input-number>
          </el-form-item>
          <el-form-item label="满分值" prop="totalScore" v-if="!form.mouldId">
            <el-input-number
                v-model="form.totalScore"
                style="width: 100%;"
                :min="1"
                :step="5"
                label="请输入满分值"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="实验方式" prop="expMode" v-show="setDept">
            <el-select v-model="form.expMode" placeholder="请选择实验方式" style="width: 100%;">
              <el-option
                  v-for="item in mySoftwareModeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="!isInternalUser"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开启预约" v-if="form.expMode !== 1" v-show="isAdmin">
            <el-switch
                v-model="form.openReservation"
                active-color="#13ce66"
                :inactive-value="0"
                :active-value="1"
            ></el-switch>
          </el-form-item>
          <el-form-item label="截止时间" prop="cutoffTime">
            <el-date-picker
                v-model="form.cutoffTime"
                type="datetime"
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择截止时间"
            />
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="box = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 选择实验方式对话框 -->
      <software-type-dialog
          :visible.sync="dialogVisible"
          :lab-exp-uid="expInfo.uid"
          :lesson-name="expInfo.name"
          :exp-uid="expInfo.expUid"
          :exp-mode="expInfo.expMode"
          @handleStartExp="handleStartExp"
      />

      <!-- 排队对话框 -->
      <lineup-dialog
          :visible.sync="lineUpDialog"
          :exp-uid="expInfo.expUid"
          :lesson-exp-uid="activeInfo.uid"
      />

      <el-dialog width="800px" :visible.sync="appointStatus">
        <el-table :data="appointData" style="width: 100%">
          <el-table-column prop="labLessonName" label="课堂名称" align="center"></el-table-column>
          <el-table-column prop="lessonName" label="实验名称" align="center"></el-table-column>
          <el-table-column prop="nickname" label="学生名称" align="center"></el-table-column>
          <el-table-column prop="reservationTime" label="预约时间" align="center"></el-table-column>
          <el-table-column label="预约状态" align="center">
            <template slot-scope="{row}">
              <el-tag
                  size="small"
                  v-text="row.status===0?'已预约':row.status===1?'已使用':'已过期'"
                  :type="row.status===0?'success':row.status===1?'warning':'danger'"
              ></el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top:15px">
          <el-pagination
              background prev-text="上一页" next-text="下一页" layout="total, prev, pager, next, jumper"
              :total="appointPage.total" :current-page="appointPage.page" :page-size="appointPage.limit"
              @current-change="handleAppointPageChange" hide-on-single-page>
          </el-pagination>
        </div>
      </el-dialog>
      <el-dialog width="900px" :visible.sync="expLogStatus" title="课堂实验日志" @close="closeDialog">
        <el-row style="margin-bottom:15px">
          <el-col :span="7">
            <el-select v-model="logVal" clearable placeholder="请选择" size="small" @change="handLogChange">
              <el-option v-for="item in expNameList" :key="item.uid" :label="item.name" :value="item.uid"></el-option>
              <el-pagination
                  layout="prev, pager, next" :total="expPage.total" @current-change="handExpPageChange"
                  :current-page="expPage.page" :page-size="expPage.limit"
                  hide-on-single-page></el-pagination>
            </el-select>
          </el-col>
          <el-col :span="13">
            <el-date-picker
                size="small" v-model="logDayVal" :picker-options="pickerOptions" type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" range-separator="至"
                end-placeholder="结束日期" @change="handLogChange"
            ></el-date-picker>
          </el-col>
          <el-col :span="4">
            <el-button size="small" type="success" @click="exportLog" v-if="curSearchKey==='exp'">导出实验日志</el-button>
            <el-button size="small" type="success" @click="exportNoExpLog" v-if="curSearchKey==='nExp'">
              导出未实验人员名单
            </el-button>
          </el-col>
        </el-row>
        <p class="exp-curSearchKey">
          <span
              v-for="(item,key) in screen" :key="key" @click="handCurSearchKey(key)"
              :class="{'active' : key === curSearchKey}"
          >{{ item }}</span>
        </p>
        <div v-if="curSearchKey==='exp'">
          <el-table :data="expLogData" style="width: 100%" height="350">
            <el-table-column prop="index" label="序号" align="center" width="80px"></el-table-column>
            <el-table-column prop="lessonName" label="课堂名称" align="center"></el-table-column>
            <el-table-column prop="expName" label="实验名称" align="center"></el-table-column>
            <el-table-column prop="nickname" label="实验学生" align="center"></el-table-column>
            <el-table-column prop="startTime" label="实验开始时间" align="center"></el-table-column>
            <el-table-column label="实验时长" align="center">
              <template slot-scope="{row}">
                <span v-text="timeTrans(row.timeSpending)"></span>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top:15px">
            <el-pagination
                background
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next, jumper"
                hide-on-single-page
                :total="expLogPage.total"
                :current-page="expLogPage.page"
                :page-size="expLogPage.limit"
                @current-change="handExpLogPageChange"
            ></el-pagination>
          </div>
        </div>
        <div v-else-if="curSearchKey==='nExp'">
          <el-table :data="expLogData" style="width: 100%" height="350">
            <el-table-column prop="username" label="账号" align="center"></el-table-column>
            <el-table-column prop="nickname" label="姓名" align="center"></el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {open_blank} from '@/utils/router'
import {selectExpList, getExpSoftByUid} from '@/api/exp/experiment'
import {add, remove, update, startExp, getMyReport, getLabExps, getEntityByUid, moveIndex} from '@/api/lab/experiment'
import {query as templateQuery} from '@/api/lab/experimentreportmould'
import isEmpty from '@/components/common/is-empty'
import softwareTypeDialog from '@/components/common/dialog-software-type'
import lineupDialog from "@/views/lesson/exp/components/line-up-dialog"
import {getStudyReservaQuery} from '@/api/io/lab-exp-reserva-log'
import {getExpLogList} from '@/api/lab/lab-exp-log'
import {formatterTime} from '@/utils/formatter'
import {packExpFile, packExpWordFile} from '@/api/file'
import {specifyNotExpList} from '@/api/lab/lesson2user'
import {exportExcel} from '@/api/common'


export default {
  components: {
    isEmpty,
    softwareTypeDialog,
    lineupDialog,
  },
  props: {
    uid: {
      type: String,
      default: "",
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    canStudy: {
      type: Boolean,
      default: false,
    },
    lessonInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      // 是否显示选择实验方式对话框
      laya3D: false,
      dialogVisible: false,
      disabled: false,
      packFlag: false,
      // pickerOptions: { //设置时间选择器的禁用时间
      //     disabledDate(time) {
      //         let a = time.getTime() < Date.now() - 3600 * 1000 * 24 * 30
      //         let b = time.getTime() > Date.now();
      //         return a || b
      //     }
      // },
      selectDate: '',
      pickerOptions: {
        onPick: ({maxDate, minDate}) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = ''
          }
        }, disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      screen: {
        exp: '实验详情',
        nExp: '未实验名单'
      },
      reports: [],
      page: {
        page: 1,
        limit: 10,
        total: 0
      },
      expPage: {
        page: 1,
        limit: 5,
        total: 0
      },
      curSearchKey: '',
      expNameList: [],
      logDayVal: '',
      logVal: '',
      box: false,
      list: [], // 课堂实验列表
      form: {},
      expList: [],
      rules: {
        expUid: [
          {required: true, message: "请选择实验项目", trigger: "blur"}
        ],
        expMode: [
          {required: true, message: "请选择实验方式", trigger: "blur"}
        ],
        totalScore: [
          {required: true, message: "请设置满分值", trigger: "blur"}
        ],
        reportNum: [
          {required: true, message: "请输入报告题目数量", trigger: "blur"}
        ],
        cutoffTime: [
          {required: true, message: "请设置截止时间", trigger: "blur"}
        ]
      },
      // 当前操作的课程实验信息
      activeInfo: {
        uid: '', // 当前选中的课程实验uid
      },
      expInfo: {
        expUid: ""
      },
      lineUpDialog: false, // 是否显示实验排队
      socket: null,
      appointPage: {
        page: 1,
        limit: 5,
        total: 0
      },
      appointStatus: false,
      appointData: [],
      appointExpUid: '',
      expLogStatus: false,
      expLogPage: {
        page: 1,
        limit: 5,
        total: 0
      },
      expLogData: [],
      groupList: []
    }
  },
  mounted() {
    this.expTimer = setInterval(this.initExpList, 30000);
  },
  beforeDestroy() {
    clearInterval(this.expTimer);
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters(['userInfo', 'token', 'isAdmin', 'isTeacher']),
    ...mapGetters('user', ['mySoftwareModeList']),
    setDept() {
      // TODO 开启预约 实验方式 打包下载
      // const {roles = []} = this.userInfo
      // return roles.indexOf(6) > -1
      return this.isAdmin || this.isTeacher
    },
    isInternalUser () {
      const { roles = [] } = this.userInfo
      return roles.indexOf(4) > -1
    },
    time() {
      let t = new Date()
      let Y = t.getFullYear()
      let M = t.getMonth() + 1
      let D = t.getDate()
      return new Date(`${Y}-${M}-${D} 00:00:00`).getTime() + 30 * 24 * 3600 * 1000
    }
  },
  methods: {
    getTemplateQuery() {  //获取报告模版列表(分页)
      const {userInfo} = this
      templateQuery(1, 1000, {createUser: userInfo.id}).then(res => {
        const {list} = res
        this.reports = list
      })
    },
    exportNoExpLog() {
      let params = {
        lessonUid: this.$route.params.uid,
        sidx: 'id desc'
      }
      if (this.logDayVal && this.logVal) {
        params = {
          lessonUid: this.$route.params.uid,
          labExpUid: this.logVal,
          startTime: this.logDayVal[0],
          endTime: this.logDayVal[1],
          sidx: 'id desc'
        }
      } else {
        this.$message.warning('请选择时间范围,再完成导出名单!')
        return
      }
      // 导出未实验人员名单
      exportExcel("lab/lesson2user/not/doexp/lessonusers", {
        ...params
      })
    },
    exportLog() {
      let params = {}
      if (this.logVal && this.logDayVal) {
        params = {
          lessonUid: this.$route.params.uid,
          labExpUid: this.logVal,
          startTime: this.logDayVal[0],
          endTime: this.logDayVal[1],
          sidx: 'id desc'
        }
      } else {
        this.$message.warning('请选择相关实验及时间范围,再完成导出日志!')
        return
      }
      exportExcel('lab/labexperimentlog', {  //导出实验人员名单
        ...params
      })
    },
    closeDialog() { //日志弹窗关闭
      this.logVal = ''
      this.logDayVal = ''
    },
    handLogChange() {  //分实验查看时
      this.expLogPage = {
        page: 1,
        limit: 5,
        total: 0
      }
      this.getExpLogList()
    },
    timeTrans(second) {
      return formatterTime(second)
    },
    openExpLog() {
      this.expLogStatus = true
      this.getExpList()
      this.handCurSearchKey()
    },
    getExpLogList() { //获取实验日志列表
      let params = {
        lessonUid: this.$route.params.uid,
        sidx: 'id desc'
      }
      if (this.logVal) {
        params.labExpUid = this.logVal
      }
      if (this.logDayVal) {
        params.startTime = this.logDayVal[0]
        params.endTime = this.logDayVal[1]
      }
      const {page, limit} = this.expLogPage
      if (this.curSearchKey === 'exp') {
        getExpLogList(page, limit, params).then(res => {
          const {totalCount, list} = res
          this.expLogData = list
          this.expLogData.forEach((item, index) => {
            item.index = index + 1 + (page - 1) * limit
            return item
          })
          this.$set(this.expLogPage, 'total', totalCount)
        })
      } else if (this.curSearchKey === 'nExp') {
        this.specifyNotExpList()
      }
    },
    /**
     * 新建分组
     */
    gotoGroupPage() {
      // TODO 新建分组
    },
    handExpLogPageChange(page) { //实验日志弹窗翻页
      this.$set(this.expLogPage, "page", page);
      this.getExpLogList()
    },
    handExpPageChange(page) {
      this.$set(this.expPage, "page", page);
      this.getExpList()
    },
    seeAppointDetail(val) {  //查看预约详情
      this.appointStatus = true
      this.appointExpUid = val
      const {page, limit} = this.appointPage
      let params = {
        expUid: this.appointExpUid,
        labLessonUid: this.$route.params.uid
      }
      getStudyReservaQuery(page, limit, params).then(res => {
        const {list, totalCount} = res
        this.$set(this.appointPage, 'total', totalCount)
        this.appointData = list
      })
    },
    handlePageChange(page) {
      this.$set(this.page, "page", page);
      this.initExpList();
    },
    handleAppointPageChange(page) { //查看详情分页
      this.$set(this.appointPage, "page", page);
      this.seeAppointDetail(this.appointExpUid)
    },
    beforeAdd() {
      let formData = {
        expMode: 0,
        periods: 0,
        isAnticheat: 0,
        openReservation: 0,
        totalScore: 100,
        reportNum: 1,
        mouldId: null,
        cutoffTime: new Date(this.time).format("yyyy-MM-dd hh:mm:ss")
      }
      try {
        formData.expMode = this.mySoftwareModeList.filter(item => !item.disabled)[0].value
      }catch (e) {
        console.warn(e)
      }
      this.form = formData;
      this.box = true;
      this.disabled = false
    },
    init() {
      this.initExpList();
      this.getTemplateQuery()
      selectExpList().then(res => {
        this.expList = res;
      })
    },
    specifyNotExpList() {
      this.expLogData = []
      if (!this.logVal && !this.logDayVal) {
        this.$message.warning('请指定课程,以及时间段,用来查询时间段内未实验的学生名单!')
      } else if (this.logVal && this.logDayVal) {
        let params = {
          labExpUid: this.logVal,
          startTime: this.logDayVal[0],
          endTime: this.logDayVal[1],
          lessonUid: this.$route.params.uid
        }
        specifyNotExpList(params).then(res => {
          this.expLogData = res
        })
      }
    },
    getExpList() {
      const {page, limit} = this.expPage
      getLabExps(page, limit, {lessonUid: this.uid, sidx: 'view_index, create_time DESC'}).then(res => {
        const {list = [], totalCount = 0} = res
        this.$set(this.expPage, 'total', totalCount)
        this.expNameList = list
      });
    },
    // 获取课堂实验列表
    initExpList() {
      const {page, limit} = this.page
      getLabExps(page, limit, {lessonUid: this.uid, sidx: 'view_index, create_time DESC'}).then(res => {
        const {list = [], totalCount = 0} = res
        this.$set(this.page, 'total', totalCount)
        this.list = list
      });
    },
    handleCommand(command, exp, index) {
      const {uid} = exp
      let type = 'down'
      switch (command) {
        case 'update':
          getEntityByUid(uid).then(res => {
            this.form = res
          })
          this.box = true
          this.disabled = true
          break
        case 'remove':
          // 删除实验
          this.$confirm('此操作将永久删除该实验，以及学生的实验记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            remove([uid]).then(() => {
              this.$message.success("操作成功！")
              this.initExpList();
            })
          }).catch(() => {
          })
          break
        case 'see':
          this.$router.push(`/exp/${uid}/expDetails`)
          break
        case 'moveup':
        case 'movedown':
          type = command.substring('move'.length)
          moveIndex(uid, type).then(() => {
            this.$message.success('操作成功!')
            this.initExpList()
          })
          break
        case 'pack':
          this.$set(this.list[index], 'packFlag', true)
          this.$message.success('开始打包,请勿重复点击打包,稍后点击下载按钮即可!')
          packExpFile(uid).then(() => {
          })
          break
        case 'packWord':
          this.$set(this.list[index], 'packFlag', true)
          this.$message.success('开始打包,请勿重复点击打包,稍后点击下载按钮即可!')
          packExpWordFile(uid).then(() => {
          })
          break
        case 'download':
          this.download(exp.name, exp.packFileUrl)
          break
        case 'downloadWord':
          this.download(exp.name, exp.wordPackFileUrl)
          break
      }
    },
    handCurSearchKey(key) {  //切换部分
      let value = key
      if (!value || !this.screen[value]) {
        value = Object.keys(this.screen)[0]
      }
      this.curSearchKey = value
      switch (value) {
        case 'exp':
          this.getExpLogList()
          break;
        case 'nExp':
          this.specifyNotExpList()
          break;
        default:
          break;
      }
    },
    cascaderChange(e) {
      if(!e) return
      let uid = e[e.length - 1] || ''
      if(!uid) return
      getExpSoftByUid(uid).then(res=>{
          if(res.length < 1) {
            this.$set(this.form,'expMode', 1)
          }else {
            const { layaUrl = '' } = JSON.parse(res[0].appprama)
            if(layaUrl) {
              this.$set(this.form,'expMode', 0)
            }else {
              this.$set(this.form,'expMode', 1)
            }
          }
      })
    },
    download(name, url) {
      const ele = document.createElement('a');
      ele.setAttribute('href', this.$options.filters['filterUrl'](url));
      ele.setAttribute('download', name);
      ele.style.display = 'none';
      document.body.appendChild(ele);
      ele.click();
      document.body.removeChild(ele);
    },
    /**
     * 打开查看实验步骤
     */
    openExpStep(fileUid) {
      const {uid} = this.$route.params
      this.$router.push({'path': `/lesson/exp/document/${uid}/${fileUid}`});
    },
    // 点击“开始实验”按钮，选择实验类型
    selectExpType(item) {
      if (!item.uid)
        return
      this.activeInfo.uid = item.uid
      this.expInfo = item
      this.dialogVisible = true
    },
    /**
     * 选择了开始实验的方式（本地、远程），开始实验
     */
    handleStartExp({ type }) {
      this.dialogVisible = false
      const {uid} = this.activeInfo
      const {id} = this.userInfo
      if (!uid || !id) {
        return
      }

      if (type === 'local') { // 本地实验
        // 获取课堂实验记录UID
        const {expUid} = this.expInfo
        let lessonUid = this.$route.params.uid
        startExp({
          expUid: uid,
          userId: id
        })
            .then(recordUid => {
              // 进入做实验页面
              this.$router.push({'path': `/lesson/exp/loaclstart/${uid}/${recordUid}/${expUid}/${lessonUid}`})
            })
      } else if (type === 'remote') { // 远程实验
        // 排队
        this.lineUpDialog = true
      }
    },
    /**
     * 进入学生报告列表界面
     */
    handleStartMark(uid) {
      let lessonUid = this.$route.params.uid
      this.$router.push({'path': `/lesson/${lessonUid}/exp/${uid}`});
    },
    /**
     * 学生查看自己的报告
     */
    handlecheckReprot(uid) {
      getMyReport(uid).then(uid => {
        open_blank({
          name: 'lessonExpMarking',
          params: {uid}
        })
      })
    },
    // 添加课堂实验
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let op = add;
          let expUid = this.form.expUid
          if (expUid instanceof Array) {
            expUid = expUid[expUid.length - 1]
          }
          Object.assign(this.form, {
            lessonUid: this.$route.params.uid,
            expUid
          })
          if (this.form.id)
            op = update;
          op(this.form).then(() => {
            this.$message.success('操作成功!');
            this.initExpList();
            this.box = false;
            this.form = {};
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less">
.lesson-lineUp-dialog {
  .el-dialog__header {
    height: 48px;
    padding: 0;
  }

  &.el-dialog--center {
    .el-dialog__body {
      text-align: center;
      padding-top: 0;
      padding-bottom: 52px;

      .lineUp-img {
        display: inline-block;
        border-radius: 50%;
        border: 1px solid #dcdcdc;
        font-size: 0;
        position: relative;

        &::after {
          width: 8px;
          height: 8px;
          content: '';
          border-radius: 50%;
          background-color: #00aafa;
          position: absolute;
          animation: lineUpIcon 2s;
          animation-iteration-count: infinite;
        }
      }

      .lineUp-wait {
        font-size: 24px;
        line-height: 3em;
        font-weight: normal;

        span {
          font-size: 1.5em;
          color: #14b41e;
          padding: 0 1em;
        }
      }

      .lineUp-btns {
        margin-top: 36px;

        .el-button {
          min-width: 120px;
        }
      }
    }
  }
}
</style>

<style lang="less" scoped>
.lesson-exp {
  padding-bottom: 20px;
}

.el-dialog {
  .dialog-cascader {
    width: 100%;
  }
}

.exp-curSearchKey {
  height: 60px;
  text-align: center;
  font: 400 18px "微软雅黑";
  border-bottom: 1px solid #dcdcdc;
  padding-bottom: 12px;

  span {
    line-height: 60px;
    padding: 0 12px;
    color: #999;
    cursor: pointer;
  }

  span:nth-of-type(1) {
    border-right: 1px solid #969696;
  }

  .active {
    color: #14b14e;
  }
}
</style>
